import React from 'react';
import Badge from '../Badge';

const BadgeList = ({ list }) => {

    return list.map( (item, key) => <Badge key={`${key}_${ Math.random() }`} >{ Number.parseFloat(item).toFixed(2)  }</Badge> )

}

export default BadgeList